import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Container, Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import Font from '../../../../../SPRINTA/atoms/Font'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import BoxEvent from '../../../../../SPRINTA/molecules/BoxEvent'
import * as user from '../../../../utils/user'
import Button from '../../../../../SPRINTA/atoms/Button'

class Affiliate extends Component {
  state = {
    isAffiliateApproved: false,
    affiliateParticipant: null,
    affiliateProgram: null,
    requestingAffiliate: false,
    affiliateRequestStatus: null,
    noActiveProgram: false,

    loadingPast: false,
    dataPast: [],
    totalPast: 0,
    loadingMorePast: false,

    loadingFuture: true,
    dataFuture: [],
    totalFuture: 0,
    loadingMoreFuture: false,

    affiliateLoading: true,
    affiliateStats: null,

    eventMaterials: {},

    copied: false,
    copiedEventId: null,
  }

  componentDidMount() {
    var userToken = this.getLoggedUserToken(this.props)

    if (!userToken) {
      this.redirectToLogin()
      return
    }

    var profileUsername = this.getProfileUsername(this.props)

    if (profileUsername) {
      this.loadAffiliateMe(profileUsername)
    } else {
      this.setState({
        loadingFuture: false,
        affiliateLoading: false,
        noActiveProgram: true,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    var currentUserToken = this.getLoggedUserToken(this.props)
    var nextUserToken = this.getLoggedUserToken(nextProps)

    var currentProfileUsername = this.getProfileUsername(this.props)
    var nextProfileUsername = this.getProfileUsername(nextProps)

    if (
      currentUserToken !== nextUserToken ||
      currentProfileUsername !== nextProfileUsername
    ) {
      if (!nextUserToken) {
        this.redirectToLogin()
        return
      }

      this.setState({
        noActiveProgram: false,
        loadingPast: false,
        dataPast: [],
        totalPast: 0,
        loadingMorePast: false,

        loadingFuture: true,
        dataFuture: [],
        totalFuture: 0,
        loadingMoreFuture: false,

        affiliateLoading: true,
        affiliateStats: null,
        affiliateParticipant: null,
        affiliateProgram: null,
        isAffiliateApproved: false,
        affiliateRequestStatus: null,

        eventMaterials: {},

        copied: false,
        copiedEventId: null,
      })

      if (nextProfileUsername) {
        this.loadAffiliateMe(nextProfileUsername)
      } else {
        this.setState({
          loadingFuture: false,
          affiliateLoading: false,
          noActiveProgram: true,
        })
      }
    }
  }

  redirectToLogin() {
    if (typeof window === 'undefined') return

    var currentUrl = window.location.href

    window.location.replace(
      'https://app.sprinta.com.br/login?redirect_to=' +
        encodeURIComponent(currentUrl)
    )
  }

  getLoggedUserToken(props) {
    props = props || this.props
    return props.user && props.user.userData && props.user.userData.token
      ? props.user.userData.token
      : ''
  }

  getProfileUsername(props) {
    props = props || this.props

    if (props && props.username) return props.username
    if (props && props.match && props.match.params && props.match.params.username) {
      return props.match.params.username
    }
    if (props && props.match && props.match.params && props.match.params.profile) {
      return props.match.params.profile
    }
    if (props && props.params && props.params.username) {
      return props.params.username
    }

    return ''
  }

  getLoggedUserUrlToken(props) {
    props = props || this.props
    return props.user && props.user.userData && props.user.userData.url_token
      ? props.user.userData.url_token
      : ''
  }

  getEventToken(item) {
    if (!item) return ''
    return item.token || item.ev_token || item.event_token || ''
  }

  getAffiliateBaseLink(userUrlToken, userToken) {
    var source = userToken || ''
    if (!source) return 'https://app.sprinta.com.br'

    return (
      'https://app.sprinta.com.br/e/?utm_source=' +
      encodeURIComponent(source) +
      '&utm_campaign=affiliate' +
      '&utm_content=' +
      encodeURIComponent(source)
    )
  }

  getAffiliateEventLink(item, userUrlToken, userToken) {
    if (!item) return ''

    var eventToken = this.getEventToken(item)
    if (!eventToken) return ''

    var source = userToken || ''
    if (!source) {
      return 'https://app.sprinta.com.br/e/' + eventToken
    }

    return (
      'https://app.sprinta.com.br/e/' +
      eventToken +
      '?utm_source=' +
      encodeURIComponent(source) +
      '&utm_campaign=affiliate' +
      '&utm_content=' +
      encodeURIComponent(source)
    )
  }

  getEventGains(item) {
    if (!item) return null

    if (item.reward_type === 'cash') {
      return {
        type: 'cash',
        percentCash: Number(item.commission_percent || 0),
        note: 'Válido para inscrições confirmadas.',
      }
    }

    return {
      type: 'points',
      points: Number(item.points_amount || 0),
      note: 'Válido para inscrições confirmadas.',
    }
  }

  parseMaterials(list) {
    return (list || []).map(function(item, index) {
      return {
        id: item.id || index,
        type: item.material_type || 'other',
        title: item.title || 'Material',
        fileUrl: item.file_url || '',
        content: item.content || '',
      }
    })
  }

  getEventMaterials(item) {
    if (!item || !item.id) {
      return []
    }

    return this.state.eventMaterials[item.id] || []
  }

  isLinkMaterial(material) {
    return !!(material && material.fileUrl)
  }

  isCopyMaterial(material) {
    return !!(material && material.content)
  }

  getMaterialLabel(material) {
    if (material && material.title) return material.title

    switch (material.type) {
      case 'feed_image':
        return 'Banner Feed'
      case 'story_image':
        return 'Story'
      case 'whatsapp_image':
        return 'WhatsApp'
      case 'pdf':
        return 'PDF'
      case 'caption':
        return 'Copiar texto'
      case 'coupon':
        return 'Copiar cupom'
      default:
        return 'Material'
    }
  }

  getMaterialColor(material) {
    switch (material.type) {
      case 'caption':
        return '#28a745'
      case 'coupon':
        return '#ff5500'
      default:
        return '#007bff'
    }
  }

  renderMaterialAction(material, item) {
    var label = this.getMaterialLabel(material)
    var color = this.getMaterialColor(material)

    if (this.isLinkMaterial(material)) {
      return (
        <span
          key={material.id}
          style={{ cursor: 'pointer', color: color }}
          onClick={function() { window.open(material.fileUrl, '_blank') }}
        >
          {label}
        </span>
      )
    }

    if (this.isCopyMaterial(material)) {
      return (
        <span
          key={material.id}
          style={{ cursor: 'pointer', color: color, fontWeight: 500 }}
          onClick={this.copyToClipboard.bind(this, material.content, item.id)}
        >
          {label}
        </span>
      )
    }

    return (
      <span key={material.id} style={{ color: '#999' }}>
        {label}
      </span>
    )
  }

  copyToClipboard(text, eventId) {
    var value = String(text || '').trim()
    if (!value) return

    try {
      var textArea = document.createElement('textarea')
      textArea.value = value
      textArea.setAttribute('readonly', '')
      textArea.style.position = 'fixed'
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.width = '1px'
      textArea.style.height = '1px'
      textArea.style.opacity = '0'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      textArea.setSelectionRange(0, value.length)

      var success = document.execCommand('copy')
      document.body.removeChild(textArea)

      if (success) {
        this.setState({ copied: true, copiedEventId: eventId })
        setTimeout(
          function() {
            this.setState({ copied: false, copiedEventId: null })
          }.bind(this),
          1500
        )
      } else {
        window.prompt('Copie o link abaixo:', value)
      }
    } catch (e) {
      window.prompt('Copie o link abaixo:', value)
    }
  }

  loadAffiliateMe(profileUsername) {
    user.affiliateMe(profileUsername)
      .then(
        function(data) {
          var participant = data && data.participant ? data.participant : null
          var program = data && data.program ? data.program : null

          if (!program) {
            this.setState({
              affiliateParticipant: null,
              affiliateProgram: null,
              isAffiliateApproved: false,
              affiliateRequestStatus: null,
              noActiveProgram: true,
              loadingFuture: false,
              affiliateLoading: false,
              dataFuture: [],
              totalFuture: 0,
              affiliateStats: {
                sales: 0,
                pendents: 0,
                revenue: 0,
                commission: 0,
              },
            })
            return
          }

          this.setState({
            affiliateParticipant: participant,
            affiliateProgram: program,
            isAffiliateApproved: !!(participant && participant.status === 'approved'),
            affiliateRequestStatus: participant && participant.status === 'pending' ? 'sent' : null,
            noActiveProgram: false,
          })

          this.loadDataFuture(profileUsername)
          this.loadAffiliateStats(profileUsername)
        }.bind(this)
      )
      .catch(
        function() {
          this.setState({
            affiliateParticipant: null,
            affiliateProgram: null,
            isAffiliateApproved: false,
            noActiveProgram: true,
            loadingFuture: false,
            affiliateLoading: false,
            dataFuture: [],
            totalFuture: 0,
            affiliateStats: {
              sales: 0,
              pendents: 0,
              revenue: 0,
              commission: 0,
            },
          })
        }.bind(this)
      )
  }

  loadAffiliateStats(profileUsername) {
    this.setState({ affiliateLoading: true })

    user.affiliateStats(profileUsername)
      .then(
        function(data) {
          this.setState({
            affiliateLoading: false,
            affiliateStats: {
              sales: Number(data && data.sales ? data.sales : 0),
              pendents: Number(data && data.pendents ? data.pendents : 0),
              revenue: Number(data && data.revenue ? data.revenue : 0),
              commission: Number(data && data.commission ? data.commission : 0),
            },
          })
        }.bind(this)
      )
      .catch(
        function() {
          this.setState({
            affiliateLoading: false,
            affiliateStats: {
              sales: 0,
              pendents: 0,
              revenue: 0,
              commission: 0,
            },
          })
        }.bind(this)
      )
  }

  loadDataFuture(profileUsername) {
    this.setState({ loadingFuture: true })

    user.affiliateEvents(profileUsername)
      .then(
        function(data) {
          var list = data && data.events ? data.events : []

          this.setState({
            loadingFuture: false,
            dataFuture: list,
            totalFuture: list.length,
            loadingMoreFuture: false,
          })

          list.forEach(
            function(item) {
              this.loadEventMaterials(item.id)
            }.bind(this)
          )
        }.bind(this)
      )
      .catch(
        function() {
          this.setState({
            loadingFuture: false,
            dataFuture: [],
            totalFuture: 0,
            loadingMoreFuture: false,
          })
        }.bind(this)
      )
  }

  loadEventMaterials(eventId) {
    if (!eventId) return

    user.affiliateMaterials(eventId)
      .then(
        function(data) {
          var list = data && data.materials ? data.materials : []
          var parsed = this.parseMaterials(list)

          this.setState(function(prevState) {
            return {
              eventMaterials: Object.assign({}, prevState.eventMaterials, {
                [eventId]: parsed,
              }),
            }
          })
        }.bind(this)
      )
      .catch(
        function() {
          this.setState(function(prevState) {
            return {
              eventMaterials: Object.assign({}, prevState.eventMaterials, {
                [eventId]: [],
              }),
            }
          })
        }.bind(this)
      )
  }

  loadMoreDataFuture() {
    return
  }

  isAffiliateApproved() {
    return !!this.state.isAffiliateApproved
  }

  requestAffiliateAccess() {
    var participant = this.state.affiliateParticipant
    var profileUsername = this.getProfileUsername(this.props)

    if (this.state.requestingAffiliate) return
    if (participant && participant.status === 'pending') return
    if (participant && participant.status === 'approved') return
    if (!profileUsername) return

    this.setState({
      requestingAffiliate: true,
      affiliateRequestStatus: null,
    })

    user.affiliateRequest(profileUsername)
      .then(
        function() {
          this.setState({
            requestingAffiliate: false,
            affiliateRequestStatus: 'sent',
          })

          this.loadAffiliateMe(profileUsername)
        }.bind(this)
      )
      .catch(
        function() {
          this.setState({
            requestingAffiliate: false,
            affiliateRequestStatus: 'error',
          })
        }.bind(this)
      )
  }

  formatMoneyBRL(value) {
    var v = Number(value || 0)
    try {
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    } catch (e) {
      var fixed = Math.round(v * 100) / 100
      return 'R$ ' + fixed.toFixed(2)
    }
  }

  renderNoActiveProgram() {
    return (
      <Row>
        <Col>
          <div
            style={{
              marginTop: '30px',
              padding: '18px',
              border: '1px solid #eee',
              borderRadius: '14px',
              background: '#fff',
            }}
          >
            <Font heading="2" color="#222" weight="700">
              Programa de Afiliados
            </Font>

            <div style={{ marginTop: '10px', color: '#666', lineHeight: 1.6 }}>
              No momento, não há programa de afiliados ativo para este perfil.
            </div>
          </div>
        </Col>
      </Row>
    )
  }

  renderAffiliateHeader(userUrlToken, userToken) {
    var participant = this.state.affiliateParticipant
    var approved = !!(participant && participant.status === 'approved')
    var pending = !!(participant && participant.status === 'pending')
    var baseLink = this.getAffiliateBaseLink(userUrlToken, userToken)

    var cardStyle = {
      marginTop: '20px',
      padding: '18px',
      border: '1px solid #eee',
      borderRadius: '14px',
      background: '#fff',
    }

    var badgeStyle = {
      display: 'inline-block',
      fontSize: '11px',
      padding: '6px 10px',
      borderRadius: '999px',
      border: '1px solid #eee',
      color: '#666',
      marginTop: '10px',
    }

    var program = this.state.affiliateProgram

    var description = program && program.description
      ? program.description
      : 'Indique eventos do Mountain Do e ganhe recompensas por cada inscrição confirmada.'

    var programName = program && program.name
      ? program.name
      : ''

    if (!approved) {
      return (
        <Row>
          <Col>
            <Font heading="2" color="#222" weight="700" style={{ marginTop: '30px' }}>
              Programa de Afiliados
            </Font>

            <Font color="#666" weight="100" style={{ marginTop: '10px' }}>
              {description}
            </Font>

            <div style={cardStyle}>
              <Font color="#222" weight="700">
                {programName}
              </Font>

              <div style={{ marginTop: '10px', color: '#666', lineHeight: 1.7, fontSize: '14px' }}>
                <ul style={{ margin: 0, paddingLeft: '18px' }}>
                  <li>Você recebe um link exclusivo para divulgar eventos.</li>
                  <li>Quando a inscrição é confirmada, você ganha recompensa automaticamente.</li>
                  <li>Os eventos participantes informam claramente a comissão disponível.</li>
                </ul>
              </div>

              <div style={badgeStyle}>
                Aprovação necessária · Sujeito a análise
              </div>

              {(pending || this.state.affiliateRequestStatus === 'sent') && (
                <div style={{ marginTop: '12px', color: '#2e7d32', fontSize: '13px' }}>
                  Solicitação enviada! Vamos analisar e te avisar.
                </div>
              )}

              {this.state.affiliateRequestStatus === 'error' && (
                <div style={{ marginTop: '12px', color: '#c62828', fontSize: '13px' }}>
                  Não foi possível enviar sua solicitação. Tente novamente.
                </div>
              )}

              <div style={{ marginTop: '14px' }}>
                <Button
                  inline
                  theme="primary"
                  onClick={this.requestAffiliateAccess.bind(this)}
                  disabled={this.state.requestingAffiliate || pending}
                >
                  {pending
                    ? 'Solicitação enviada'
                    : this.state.requestingAffiliate
                    ? 'Enviando...'
                    : 'Solicitar participação'}
                </Button>

                <span style={{ marginLeft: '12px', color: '#888', fontSize: '12px' }}>
                  Ao solicitar, você concorda com as regras do programa.
                </span>
              </div>
            </div>
          </Col>
        </Row>
      )
    }

    return (
      <Row>
        <Col>
          <Font heading="2" color="#222" weight="700" style={{ marginTop: '30px' }}>
            Programa de Afiliados
          </Font>

          <Font color="#666" weight="100" style={{ marginTop: '10px' }}>
            Seu acesso está ativo. Use seu link para divulgar eventos e acumular ganhos.
          </Font>

          <div style={cardStyle}>
            <Font color="#444" weight="700">
              {programName}
            </Font>

            <div style={{ marginTop: '0px', wordBreak: 'break-all', color: '#666' }}>
              <Font color="#666" weight="100" style={{ marginTop: '10px' }}>
                {description}
              </Font>
            </div>

            {/* <div style={{ marginTop: '12px' }}>
              <Button inline theme="primary" onClick={this.copyToClipboard.bind(this, baseLink, null)}>
                {this.state.copied && !this.state.copiedEventId ? 'Copiado' : 'Copiar link'}
              </Button>
            </div> */}
          </div>
        </Col>
      </Row>
    )
  }

  renderAffiliateStats() {
    var affiliateLoading = this.state.affiliateLoading
    var affiliateStats = this.state.affiliateStats || {}

    return (
      <Row>
        <Col>
          <div style={{ marginTop: '20px', padding: '16px', border: '1px solid #eee', borderRadius: '10px' }}>
            <Font color="#444" weight="700">
              Seus ganhos
            </Font>

            {affiliateLoading ? (
              <div style={{ marginTop: '12px' }}>
                <Loading />
              </div>
            ) : (
              <Row style={{ marginTop: '12px' }}>
                <Col size="12 4" style={{ marginTop: '10px' }}>
                  <div style={{ padding: '12px', border: '1px solid #f0f0f0', borderRadius: '10px' }}>
                    <div style={{ fontSize: '12px', color: '#888' }}>Vendas confirmadas</div>
                    <div style={{ fontSize: '22px', color: '#222', fontWeight: 700 }}>
                      {affiliateStats.sales || 0}
                    </div>
                  </div>
                </Col>

                <Col size="12 4" style={{ marginTop: '10px' }}>
                  <div style={{ padding: '12px', border: '1px solid #f0f0f0', borderRadius: '10px' }}>
                    <div style={{ fontSize: '12px', color: '#888' }}>Vendas pendentes</div>
                    <div style={{ fontSize: '22px', color: '#222', fontWeight: 700 }}>
                      {affiliateStats.pendents || 0}
                    </div>
                  </div>
                </Col>

                <Col size="12 4" style={{ marginTop: '10px' }}>
                  <div style={{ padding: '12px', border: '1px solid #f0f0f0', borderRadius: '10px' }}>
                    <div style={{ fontSize: '12px', color: '#888' }}>Comissão</div>
                    <div style={{ fontSize: '22px', color: '#222', fontWeight: 700 }}>
                      {this.formatMoneyBRL(affiliateStats.commission)}
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    )
  }

  renderEarningsBox() {
    return (
      <Row>
        <Col>
          <div style={{ marginTop: '20px', padding: '16px', border: '1px solid #eee', borderRadius: '10px' }}>
            <Font color="#444" weight="700">
              Como você ganha
            </Font>

            <div style={{ marginTop: '12px', color: '#666', lineHeight: 1.6 }}>
              <ul style={{ margin: 0, paddingLeft: '18px' }}>
                <li>Comissão por inscrição confirmada (pagamento aprovado).</li>
                <li>Cancelamentos e estornos não geram comissão.</li>
                <li>O link identifica você automaticamente suas vendas.</li>
                <li>Você pode divulgar em redes sociais, grupos e WhatsApp.</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    )
  }

  renderEventList(title, list, userUrlToken, userToken) {
    if (!list || list.length === 0) return null

    return (
      <Row>
        <Col>
          <Row>
            <Col size="6">
              <Font color="#666" weight="100" style={{ margin: '30px 0 10px' }}>
                {title}
              </Font>
            </Col>
          </Row>

          <Row>
            {list.map(
              function(item) {
                var affiliateLink = this.getAffiliateEventLink(item, userUrlToken, userToken)
                var materials = this.getEventMaterials(item)
                var gains = this.getEventGains(item)

                return (
                  <Col size="12 4" key={item.id} style={{ marginTop: '20px' }}>
                    <div style={{ border: '1px solid #eee', borderRadius: '12px', overflow: 'hidden' }}>
                      <a href={'/' + item.kind + '/' + this.getEventToken(item)}>
                        <BoxEvent
                          data={{
                            cover: item.coverImagePath,
                            type: item.kind,
                            date: item.startDate,
                            state_abbreviation: item.region,
                            city: item.city,
                            title: item.title,
                          }}
                        />
                      </a>

                      <div style={{ padding: '12px', marginTop: '20px' }}>
                        <div style={{ fontSize: '12px', color: '#666', wordBreak: 'break-all' }}>
                          <br />
                        </div>

                        <div style={{ marginTop: '20px' }}>
                          <Button inline theme="primary" onClick={this.copyToClipboard.bind(this, affiliateLink, item.id)}>
                            {this.state.copiedEventId === item.id ? 'Copiado' : 'Copiar link para divulgação'}
                          </Button>

                          <span style={{ marginLeft: '10px' }}>
                            <Button inline theme="secondary" onClick={function() { window.open(affiliateLink, '_blank') }}>
                              Abrir
                            </Button>
                          </span>
                        </div>

                        <div style={{ marginTop: '15px', borderTop: '1px solid #f0f0f0', paddingTop: '12px' }}>
                          <div style={{ fontSize: '12px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                            Ganhos neste evento
                          </div>

                          <div style={{ fontSize: '12px', color: '#666', lineHeight: 1.7 }}>
                            {gains && gains.type === 'cash' ? (
                              <div>
                                <span style={{ color: '#222', fontWeight: 600 }}>Dinheiro:</span>{' '}
                                {gains.percentCash}% por inscrição confirmada
                              </div>
                            ) : (
                              <div>
                                <span style={{ color: '#222', fontWeight: 600 }}>Pontos:</span>{' '}
                                {gains.points} pontos para trocar no marketplace
                              </div>
                            )}

                            {!!gains && !!gains.note && (
                              <div style={{ marginTop: '6px', color: '#888' }}>{gains.note}</div>
                            )}
                          </div>
                        </div>

                        <div style={{ marginTop: '15px', borderTop: '1px solid #f0f0f0', paddingTop: '12px' }}>
                          <div style={{ fontSize: '12px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                            Materiais para divulgação
                          </div>

                          <div style={{ fontSize: '12px', color: '#666', lineHeight: 1.6 }}>
                            {materials && materials.length > 0 ? (
                              materials.map(
                                function(material, index) {
                                  return (
                                    <span key={material.id || index}>
                                      {index > 0 && <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>}
                                      {this.renderMaterialAction(material, item)}
                                    </span>
                                  )
                                }.bind(this)
                              )
                            ) : (
                              <span style={{ color: '#999' }}>Nenhum material disponível</span>
                            )}
                          </div>

                          {materials && materials.length > 0 && materials.map(
                            function(material, index) {
                              if (material.type !== 'coupon' || !material.content) return null

                              return (
                                <div key={'coupon_' + (material.id || index)} style={{ marginTop: '10px', fontSize: '12px', color: '#444' }}>
                                  {material.title ? material.title + ': ' : 'Cupom disponível: '}
                                  <strong>{material.content}</strong>
                                </div>
                              )
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                )
              }.bind(this)
            )}
          </Row>
        </Col>
      </Row>
    )
  }

  render() {
    console.log('PROPS COMPLETO', this.props)
    var userToken = this.getLoggedUserToken(this.props)

    if (!userToken) {
      return null
    }

    var userUrlToken = this.getLoggedUserUrlToken(this.props)

    if (this.state.loadingFuture) {
      return (
        <Container>
          <Row>
            <Col>
              <Placeholder type="retangle" style={{ width: '240px', marginTop: '20px', height: '40px' }} />
              <Placeholder type="retangle" style={{ marginTop: '20px', height: '120px' }} />
              <Row>
                <Col size="12 4">
                  <Placeholder type="retangle" style={{ marginTop: '20px', height: '150px' }} />
                </Col>
                <Col size="12 4">
                  <Placeholder type="retangle" style={{ marginTop: '20px', height: '150px' }} />
                </Col>
                <Col size="12 4">
                  <Placeholder type="retangle" style={{ marginTop: '20px', height: '150px' }} />
                </Col>
              </Row>
              <br />
            </Col>
          </Row>
        </Container>
      )
    }

    if (this.state.noActiveProgram) {
      return (
        <Container style={{ paddingBottom: '30px' }}>
          {this.renderNoActiveProgram()}
        </Container>
      )
    }

    return (
      <Container style={{ paddingBottom: '30px' }}>
        {this.renderAffiliateHeader(userUrlToken, userToken)}
        {this.renderAffiliateStats()}
        {this.renderEarningsBox()}

        {this.state.isAffiliateApproved &&
          this.renderEventList('Eventos para divulgar', this.state.dataFuture, userUrlToken, userToken)}
      </Container>
    )
  }
}

var mapStateToProps = function(store) {
  return {
    user: store.user,
  }
}

export default connect(mapStateToProps, {})(Affiliate)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Affiliate/index.js